import React from 'react'
import styled from 'styled-components'
import {graphql, Link, useStaticQuery} from 'gatsby'
import PropTypes from 'prop-types'
import {useStore} from '../../utils/store'

const Holder = styled.nav`
  ul {
    list-style: none;
    padding-left: 0;
    border-top: 1px solid ${props => props.theme.colours.grey3};
    margin: 0;
    @media ( ${props => props.theme.breakpoints.md} ) {
      border-top: none;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: ${props => props.theme.colours.white};
    }

    li {
      ${(props) => props.theme.fluidType(1)};
      margin: 1rem 0;
      @media ( ${props => props.theme.breakpoints.md} ) {
        margin: 0 0 0 1rem;
        ${(props) => props.theme.fluidType(-1)};
      }

      a {
        text-decoration: none;
        font-weight: bold;
      }

      a[aria-current="page"] {
        border-bottom: 2px solid ${props => props.theme.colours.yellow};
      }

      .button {
        ${(props) => props.theme.fluidType(0)};
        margin-top: 2rem;
        @media ( ${props => props.theme.breakpoints.md} ) {
          margin-top: 0;
          ${(props) => props.theme.fluidType(-1)};
        }
      }
    }
  }
`

function Navigation({clickHandler}) {
    const openContact = useStore(state => state.openContact)

    const handleClick = () => {
        clickHandler()
    }

    const data = useStaticQuery(graphql`
    query {
      prismicCaseStudyIndex {
        data {
          launch_case_studies
        }
      }
    }
  `)
    const toggle = data.prismicCaseStudyIndex.data.launch_case_studies

    return <Holder className="navigation">
        <ul onClick={() => handleClick()}>
            <li><Link to="/how">How It Works</Link></li>
            <li><Link to="/why">Why Go Electric</Link></li>
            <li><Link to="/bus-talk">Bus Talk</Link></li>
            <li><Link to="/articles">Blog</Link></li>
            <li><Link to="/about">About Us</Link></li>
            {toggle === true &&
                <li><Link to="/case-study">Case Studies</Link></li>}
            <li><Link to="/careers">Careers</Link></li>
            <li>
                <button onClick={() => openContact()} className="button">Contact Us</button>
            </li>
        </ul>
    </Holder>
}

Navigation.propTypes = {
    clickHandler: PropTypes.func,
}

Navigation.defaultProps = {
    clickHandler: () => {
        return null
    },
}

export default Navigation
